/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IBeneficiaryCreateMutationVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
  beneficiaryParams: Types.IEscrowPartyParams;
}>;

export type IBeneficiaryCreateMutation = {
  __typename?: 'Mutation';
  beneficiaryCreate?: {
    __typename?: 'BeneficiaryCreatePayload';
    success: boolean;
    errors?: Array<string> | null;
    beneficiary?: {
      __typename?: 'Beneficiary';
      escrow:
        | {
            __typename?: 'ContinuityEscrow';
            id: string;
            beneficiaryConfigured: boolean;
            beneficiary?: {
              __typename?: 'Beneficiary';
              city?: string | null;
              companyName?: string | null;
              companyRegistrationNumber?: string | null;
              companyWebsite?: string | null;
              country?: string | null;
              id: string;
              postalCode?: string | null;
              region?: string | null;
              street?: string | null;
              streetNumber?: string | null;
              contacts: Array<{
                __typename?: 'Contact';
                id: string;
                email: string;
                name: string;
                phone?: string | null;
                signatory: boolean;
                contactType: Types.ContactTypeEnum;
              }>;
              policy: {
                __typename?: 'BeneficiaryPolicy';
                update: boolean;
                readEscrowMemberships: boolean;
                createEscrowMemberships: boolean;
              };
            } | null;
          }
        | {
            __typename?: 'SaasEscrow';
            id: string;
            beneficiaryConfigured: boolean;
            beneficiary?: {
              __typename?: 'Beneficiary';
              city?: string | null;
              companyName?: string | null;
              companyRegistrationNumber?: string | null;
              companyWebsite?: string | null;
              country?: string | null;
              id: string;
              postalCode?: string | null;
              region?: string | null;
              street?: string | null;
              streetNumber?: string | null;
              contacts: Array<{
                __typename?: 'Contact';
                id: string;
                email: string;
                name: string;
                phone?: string | null;
                signatory: boolean;
                contactType: Types.ContactTypeEnum;
              }>;
              policy: {
                __typename?: 'BeneficiaryPolicy';
                update: boolean;
                readEscrowMemberships: boolean;
                createEscrowMemberships: boolean;
              };
            } | null;
          }
        | {
            __typename?: 'SoftwareEscrow';
            id: string;
            beneficiaryConfigured: boolean;
            policy: { __typename?: 'SoftwareEscrowPolicy'; createBeneficiary: boolean };
            beneficiary?: {
              __typename?: 'Beneficiary';
              city?: string | null;
              companyName?: string | null;
              companyRegistrationNumber?: string | null;
              companyWebsite?: string | null;
              country?: string | null;
              id: string;
              postalCode?: string | null;
              region?: string | null;
              street?: string | null;
              streetNumber?: string | null;
              contacts: Array<{
                __typename?: 'Contact';
                id: string;
                email: string;
                name: string;
                phone?: string | null;
                signatory: boolean;
                contactType: Types.ContactTypeEnum;
              }>;
              policy: {
                __typename?: 'BeneficiaryPolicy';
                update: boolean;
                readEscrowMemberships: boolean;
                createEscrowMemberships: boolean;
              };
            } | null;
          };
    } | null;
  } | null;
};

export const BeneficiaryCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'beneficiaryCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'beneficiaryParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowPartyParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'beneficiaryCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'beneficiaryParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'beneficiaryParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beneficiary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryConfigured' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'beneficiary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeneficiaryFields' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SoftwareEscrow' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'policy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createBeneficiary' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Contact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signatory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeneficiaryPolicyFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeneficiaryPolicy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'update' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readEscrowMemberships' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createEscrowMemberships' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeneficiaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Beneficiary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyRegistrationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ContactFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeneficiaryPolicyFragment' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IBeneficiaryCreateMutation, IBeneficiaryCreateMutationVariables>;
